module.exports = __webpack_public_path__ + "img/bns-white.12608fb3.svg";